import { EditableText } from '@inmoment/the-kitchen';
import * as React from 'react';
import { AlertInlineMainDocumentation } from '../AlertInlineMainDocumentation';
import { AppTitleBarDocumentation } from '../AppTitleBarDocumentation';
import { BasicTileDocumentation } from '../BasicTileDocumentation';
import { CalendarDocumentation } from '../CalendarDocumentation';
import { ChartWrapperDocumentation } from '../ChartWrapperDocumentation';
import { CheckboxDocumentation } from '../CheckboxDocumentation';
import { CondensedExperienceCardDocumentation } from '../CondensedExperienceCardDocumentation';
import { DefaultButtonDocumentation } from '../DefaultButtonDocumentation';
import { DrawerDocumentation } from '../DrawerDocumentation';
import { DropdownDocumentation } from '../DropdownDocumentation';
import { ExperienceCardDocumentation } from '../ExperienceCardDocumentation';
import { FABDocumentation } from '../FABDocumentation';
import { GenericModalDocumentation } from '../GenericModalDocumentation';
import { IconButtonDocumentation } from '../IconButtonDocumentation';
import { InputFieldDocumentation } from '../InputFieldDocumentation';
import { LeftRightPickerDocumentation } from '../LeftRightPickerDocumentation';
import { RadioDocumentation } from '../RadioDocumentation';
import { SearchBoxDocumentation } from '../SearchBoxDocumentation';
import { SidePanelDocumentation } from '../SidePanelDocumentation';
import { SliderDocumentation } from '../SliderDocumentation';
import { SnackBarDocumentation } from '../SnackBarDocumentation';
import { SuccessToasterDocumentation } from '../SuccessToasterDocumentation';
import { TabBarDocumentation } from '../TabBarDocumentation';
import { TreePickerDocumentation } from '../TreePickerDocumentation';
import { ToggleSwitchDocumentation } from '../ToggleSwitchDocumentation';
import { ToggleTextDocumentation } from '../ToggleTextDocumentation';
import { WarningPopupDocumentation } from '../WarningPopupDocumentation';
import { HierarchyPickerDocumentation } from '../HierarchyPickerDocumentation';

export const switchFurtherDescription = (name: string) => {
  switch (name) {
    case 'AlertInlineMain':
      return <AlertInlineMainDocumentation />;
    case 'AppTitleBar':
      return <AppTitleBarDocumentation />;
    case 'BasicTile':
      return <BasicTileDocumentation />;
    case 'Calendar':
      return <CalendarDocumentation />;
    case 'ChartWrapper':
      return <ChartWrapperDocumentation />;
    case 'Checkbox':
      return <CheckboxDocumentation />;
    case 'CondensedExperienceCard':
      return <CondensedExperienceCardDocumentation />;
    case 'DefaultButton':
      return <DefaultButtonDocumentation />;
    case 'Drawer':
      return <DrawerDocumentation />;
    case 'Dropdown':
      return <DropdownDocumentation />;
    case 'EditableText':
      return <EditableText />;
    case 'ExperienceCard':
      return <ExperienceCardDocumentation />;
    case 'FAB':
      return <FABDocumentation />;
    case 'GenericModal':
      return <GenericModalDocumentation />;
    case 'HierarchyPicker':
      return <HierarchyPickerDocumentation />;
    case 'IconButton':
      return <IconButtonDocumentation />;
    case 'InputField':
      return <InputFieldDocumentation />;
    case 'LeftRightPicker':
      return <LeftRightPickerDocumentation />;
    case 'Radio':
      return <RadioDocumentation />;
    case 'SearchBox':
      return <SearchBoxDocumentation />;
    case 'SidePanel':
      return <SidePanelDocumentation />;
    case 'Slider':
      return <SliderDocumentation />;
    case 'SnackBar':
      return <SnackBarDocumentation />;
    case 'SuccessToaster':
      return <SuccessToasterDocumentation />;
    case 'TabBar':
      return <TabBarDocumentation />;
    case 'TreePicker':
      return <TreePickerDocumentation />;
    case 'ToggleSwitch':
      return <ToggleSwitchDocumentation />;
    case 'ToggleText':
      return <ToggleTextDocumentation />;
    case 'WarningPopup':
      return <WarningPopupDocumentation />;
    default:
      return undefined;
  }
};
